import {LeadOrderList} from "./LeadOrderList";
import {LeadOrderEdit} from "./LeadOrderEdit";
import {LeadOrderCreate} from "./LeadOrderCreate";

export default {
    list: LeadOrderList,
    create: LeadOrderCreate,
    edit: LeadOrderEdit
};
